import axios from "@/app/plugins/Axios";

function listar(paginacao) {
  return axios
    .get("lotes", { params: paginacao })
    .then((response) => response.data);
}

function buscar(busca) {
  return axios
    .get(`lotes/buscar?busca=${busca}`)
    .then((response) => response.data);
}

function buscarPorCodigo(codigo) {
  return axios
    .get(`lotes/buscarCodigo?codigo=${codigo}`)
    .then((response) => response.data);
}

function abrir(id) {
  return axios.get(`/lotes/${id}`).then((response) => response.data);
}

function salvar(lote) {
  return axios.post("/lotes", lote).then((response) => response.data);
}

function atualizar(lote) {
  return axios.put(`/lotes/${lote.id}`, lote).then((response) => response.data);
}

function excluir(id) {
  return axios.delete(`/lotes/${id}`).then((response) => response.data);
}

export default {
  listar,
  buscar,
  buscarPorCodigo,
  abrir,
  salvar,
  atualizar,
  excluir,
};
